import axios from 'axios';

import { addQueryParams, getAuthToken } from '@services/service';
import { User } from '@app-types/user.type';

const BASE_URL = process.env.REACT_APP_USERS_URL as string;

type UserInclude = 'vehicles' | 'roles';

export const getById = async (
    id: number,
    includes?: UserInclude[]
): Promise<User | null> => {
    console.log('User Service: getting user by id');
    try {
        const params = addQueryParams({ includes: includes?.join(',') });
        const response = await axios.get(
            `${BASE_URL}/api/admin/users/${id}${params}`,
            {
                headers: { Authorization: getAuthToken() },
            }
        );
        return response.data.data;
    } catch (err) {
        console.error('Error getting users:', err);
        return null;
    }
};
